import React, { useMemo } from "react";
import { FLAT_RATE_PLANS, flatRatePlanNames } from "@common/flatRateBilling";
import { getOrganizationAssignablePlans } from "@common/constants/organization-billing";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

export const PlanFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const allowedPlans = useActiveOrganization()?.allowedPlans;
    const options: FilterMultiselectOption[] = useMemo(
        () =>
            getOrganizationAssignablePlans(allowedPlans).map((plan) => ({
                value: plan,
                label: flatRatePlanNames[plan],
                searchableLabel: flatRatePlanNames[plan],
            })),
        [allowedPlans],
    );
    const value = filters.plans ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    onChange({
                        plans:
                            val.length > 0
                                ? (val as FLAT_RATE_PLANS[])
                                : undefined,
                    });
                }}
                name="plans"
                onBlur={noop}
            />
        </div>
    );
};
